import Agenda from 'react-big-calendar/lib/Agenda'
import dates from 'react-big-calendar/lib/utils/dates'
import message from 'react-big-calendar/lib/utils/messages'
import { accessor as get } from 'react-big-calendar/lib/utils/accessors'
import { inRange } from 'react-big-calendar/lib/utils/eventLevels'
import { isSelected } from 'react-big-calendar/lib/utils/selection'
import localizer from 'react-big-calendar/lib/localizer'
import { cloneDeep } from 'lodash'

import i18n from '@/i18n'

import {
  getTrainingType,
  getTimezoneShortName,
  formatStartAndEndDates,
  getDates,
} from '../../helpers/helpers'
import API from '../../api/api'
import Alert from '../../Alert'
import Icon from '../Icons'

class CalendarAgenda extends Agenda {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
    }
    this.customRenderDay = this.customRenderDay.bind(this)
    this.renderStatus = this.renderStatus.bind(this)
    this.checkInClient = this.checkInClient.bind(this)
  }

  checkInClient(e, training) {
    e.preventDefault()
    const { updateCalendarEvent } = this.props
    const client = training.clients[0]
    const trainingId = training.id
    this.setState({ loading: trainingId })
    API.checkIn(JSON.stringify([client.id]), trainingId)
      .then(() => {
        const newEvent = cloneDeep(training)
        newEvent.clients[0].participation = true
        updateCalendarEvent(newEvent)
        this.setState({ loading: false })
      })
      .catch((err) => {
        this.setState({ loading: false })
        Alert.open(err.message)
      })
  }

  renderStatus(training) {
    if (getTrainingType(training) === 'appointment') {
      let client = training.clients[0]
      if (client.participation) {
        return (
          <button className="button is-small is-success is-rounded is-hovered has-icon">
            <Icon icon={'checkmark'} viewBox={'0 0 40 30'} />
            {i18n.t('calendar:agenda.checkedIn')}
          </button>
        )
      } else {
        return (
          <button
            className={`button is-small is-outlined is-active ${
              this.state.loading === training.id ? 'is-loading' : ''
            }`}
            onClick={(e) => this.checkInClient(e, training)}
          >
            {i18n.t('calendar:agenda.checkIn')}
          </button>
        )
      }
    }
  }

  customRenderDay(day, events, dayKey) {
    let {
      culture,
      components,
      titleAccessor,
      agendaDateFormat,
      eventPropGetter,
      startAccessor,
      endAccessor,
      selected,
    } = this.props

    let EventComponent = components.event
    let DateComponent = components.date

    events = events.filter((e) => inRange(e, day, day, this.props))

    return events.map((event, idx) => {
      const { className, style } = eventPropGetter
        ? eventPropGetter(
            event,
            get(event, startAccessor),
            get(event, endAccessor),
            isSelected(event, selected),
          )
        : {}
      let dateLabel = idx === 0 && localizer.format(day, agendaDateFormat, culture)
      let first =
        idx === 0 ? (
          <td rowSpan={events.length} className="rbc-agenda-date-cell">
            {DateComponent ? <DateComponent day={day} label={dateLabel} /> : dateLabel}
          </td>
        ) : (
          false
        )
      let title = get(event, titleAccessor)
      const trainingType = getTrainingType(event)
      let [start, end] = formatStartAndEndDates(
        trainingType,
        event,
        event.buildingId ? event.buildingId.timezone : 'America/Chicago',
      )
      return (
        <tr key={dayKey + '_' + idx} className={className} style={style}>
          {first}
          {event.isMultiday ? (
            <td className="rbc-agenda-time-cell">
              <span className="ctp-agenda-timezone">
                {getDates(event, event.buildingId ? event.buildingId.timezone : 'America/Chicago')}
              </span>
            </td>
          ) : (
            <td className="rbc-agenda-time-cell">
              {start} - {end}{' '}
              <span className="ctp-agenda-timezone">
                {getTimezoneShortName(
                  event.buildingId ? event.buildingId.timezone : 'America/Chicago',
                )}
              </span>
            </td>
          )}
          <td className="rbc-agenda-status-cell">{this.renderStatus(event)}</td>
          <td className="rbc-agenda-event-cell">
            {EventComponent ? <EventComponent event={event} title={title} /> : title}
          </td>
        </tr>
      )
    }, [])
  }

  render() {
    let { length, date, events, startAccessor } = this.props
    let messages = message(this.props.messages)
    let end = dates.add(date, length, 'day')

    let range = dates.range(date, end, 'day')

    events = events.filter((event) => inRange(event, date, end, this.props))

    events.sort((a, b) => +get(a, startAccessor) - +get(b, startAccessor))

    return (
      <div className="rbc-agenda-view rbc-agenda-view--with-checkin">
        <table ref="header" className="rbc-agenda-table">
          <thead>
            <tr>
              <th className="rbc-header" ref="dateCol">
                {messages.date}
              </th>
              <th className="rbc-header" ref="timeCol">
                {messages.time}
              </th>
              <th className="rbc-header">{i18n.t('calendar:agenda.status')}</th>
              <th className="rbc-header">{messages.event}</th>
            </tr>
          </thead>
        </table>
        <div className="rbc-agenda-content" ref="content">
          <table className="rbc-agenda-table">
            <tbody ref="tbody">
              {range.map((day, idx) => this.customRenderDay(day, events, idx))}
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

export default CalendarAgenda
